import config from './config.js';

let virusIdCounter = 0;

export class Virus {
    constructor() {
        this.id = virusIdCounter++;
        this.x = Math.random() * config.gameWidth;
        this.y = Math.random() * config.gameHeight;
        this.mass = Math.random() * (config.virus.defaultMass.to - config.virus.defaultMass.from) + config.virus.defaultMass.from;
        this.radius = Math.sqrt(this.mass / Math.PI) * 10;
        this.fill = config.virus.fill;
        this.stroke = config.virus.stroke;
    }
}
